import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Url } from "url";

function SidebarNavItem(props: {
    children: React.ReactNode[];
    link: string,
    inactiveIcon: string,
    activeIcon: string
}) {
    const [active, setActive] = React.useState(false);
    const location = useLocation();

    // change active status if location changes
    React.useEffect(() => {
        setActive(location.pathname === props.link);
    }, [location, props.link]);

    return (
        <Link to={props.link}>
            <div className={`flex px-6 py-3 ${ active ? 'border-l-logo-green border-l-1 bg-light-green text-logo-green' : 'text-grey-300' }`}>
                <img className={`px-2 ${ active ? '' : 'hidden' }`} src={props.activeIcon} alt="" />
                <img className={`px-2 ${ active ? 'hidden' : '' }`} src={props.inactiveIcon} alt="" />
                {props.children}
            </div>
        </Link>
    )
}
export default SidebarNavItem;